import { render, staticRenderFns } from "./AdministratorList.vue?vue&type=template&id=439a9544&scoped=true"
import script from "./AdministratorList.vue?vue&type=script&lang=js"
export * from "./AdministratorList.vue?vue&type=script&lang=js"
import style0 from "./AdministratorList.vue?vue&type=style&index=0&id=439a9544&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a9544",
  null
  
)

export default component.exports